<template>
  <h1>Nuevo Equipo</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>